/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";

import { DataGridPro, LicenseInfo, useGridApiRef } from "@mui/x-data-grid-pro";
import { WorkItem } from "./WorkItem";
import { Box, Card, CardHeader } from "@common-ui/ui";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
// import { getWorkItemTimes } from "../../services";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const DetailPanels = (props) => {
  // const [expandedRows, setExpandedRows] = React.useState([]);
  const apiRef = useGridApiRef();
  const newWorkItems = useSelector((state) => state.workItems);

  // const expandedRowIds = apiRef?.current?.getExpandedDetailPanels
  //   ? apiRef.current?.getExpandedDetailPanels()
  //   : [];
  // console.log("expandedRowIds", expandedRowIds);

  const getDetailPanelContent = React.useCallback(
    ({ row }) => {
      let mode = row?.status === "IN_PROGRESS" ? "INTERACTIVE" : "VIEW";
      if (newWorkItems[row?.id]?.actionButtonState === "STOP") {
        mode = "VIEW";
        if (row?.status === "IN_PROGRESS") {
          mode = "INTERACTIVE";
        }
      }

      // console.log(
      //   "newWorkItems[row?.id]?.actionButtonState",
      //   newWorkItems[row?.id]?.actionButtonState,
      //   row.id
      // );
      // console.log("mode", mode);

      // // if (props.workEvent?.status !== "Published") {
      // //   status = "NOT STARTED";
      // // }
      // status = row?.status;
      // // Currently only the IN PROGESS status allows edit operation.
      // let mode = status === "IN_PROGRESS" ? "INTERACTIVE" : "VIEW";
      // // console.log("row", row?.actionButtonState);
      // // console.log("newWorkItems[row?.id]", newWorkItems[row?.id]);
      // if (newWorkItems[row?.id]?.actionButtonState) {
      //   if (newWorkItems[row?.id]?.actionButtonState === "START") {
      //     mode = "INTERACTIVE";
      //   } else {
      //     mode = "VIEW";
      //   }
      // } else {
      //   mode = "VIEW";
      // }

      return (
        <WorkItem
          row={row}
          orgID={props.orgID}
          mode={mode}
          workItemStatusChange={props?.workItemStatusChange}
        />
      );
    },
    [JSON.stringify(newWorkItems)]
  );

  const getDetailPanelHeight = React.useCallback(() => "auto", []);

  return (
    <Card sx={{ width: "100%", border: 0 }}>
      <CardHeader
        title={
          <Typography variant="h6" fontWeight="700">
            Work Item List
          </Typography>
        }
        action={props.Add}
      />
      <Box
        sx={{
          // height: "calc(100vh - 2*58px - 10px)",
          height: "100%",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-detailPanel": {
            backgroundColor: "#F8F8F8",
          },
        }}
      >
        <DataGridPro
          getRowClassName={(params) => `update-row-style-${params.id}`}
          apiRef={apiRef}
          sx={{
            border: 0,
            ".MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "&.MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: "#F8F8F8",
              border: "1px solid #EBEBEB",
              minHeight: "40px !important",
              maxHeight: "40px !important",
              lineHeight: "40px !important",
            },
            ".MuiDataGrid-virtualScroller": {
              marginTop: "40px",
            },
          }}
          autoHeight={true}
          loading={props.isLoading}
          rows={props.data}
          density="comfortable"
          columns={props.columns}
          pagination
          disableSelectionOnClick
          rowThreshold={0}
          getDetailPanelHeight={getDetailPanelHeight}
          getDetailPanelContent={getDetailPanelContent}
          components={{
            DetailPanelCollapseIcon: ExpandLess,
            DetailPanelExpandIcon: ExpandMore,
          }}
        />
      </Box>
    </Card>
  );
};
